import { generateBaseQueryKeysList } from '@/queries/utils';

export const EMPLOYEE_KEYS = {
  main: 'employees',
};

export const employeesQueryKeys = generateBaseQueryKeysList(EMPLOYEE_KEYS.main);
